import type { ReactNode } from 'react';
import { cx } from '../cx';

export type PhoneFrameProps = {
  /** The real screen, built from the same components. */
  children: ReactNode;
  /** What the screen shows, for screen readers ("The For you screen of the JobCrawls app"). */
  label: string;
  className?: string;
};

/** A plain phone frame around a real app screen: no fake device chrome, no notch art. */
export function PhoneFrame({ children, label, className }: PhoneFrameProps) {
  return (
    <figure
      aria-label={label}
      className={cx('m-0 w-72 shrink-0 rounded-jc-container bg-jc-ink p-2.5 shadow-jc-lg', className)}
    >
      <div className="h-140 overflow-hidden rounded-jc-container bg-jc-page">{children}</div>
    </figure>
  );
}
